import { faVideo } from '@fortawesome/free-solid-svg-icons';
import React from 'react';

import { ALERT_BAR_BOTTOM_CLASS, MEMBER_JOIN_ALERT_BAR_Z_CLASS } from '@/constants/layout';
import { AlertDialogPill } from '@/ui';
import { cn } from '@/ui/lib/utils';

import type { Props } from './types';

const MemberJoinedAlertBar = ({ alerts, onDismiss, onMaximize }: Props) => {
  if (!alerts.length) {
    return null;
  }

  return (
    <div
      className={cn(
        // ActiveCallOverlay owns bottom-4 inset-x-4 on small screens, so clear it;
        // from sm it is centred, so anchor to the right instead.
        'fixed inset-x-4',
        ALERT_BAR_BOTTOM_CLASS,
        'sm:inset-x-auto sm:right-4 sm:bottom-4',
        MEMBER_JOIN_ALERT_BAR_Z_CLASS,
        'flex flex-col-reverse gap-2 sm:flex-row sm:items-center'
      )}>
      {alerts.map((alert) => (
        <AlertDialogPill
          key={alert.collapseId}
          icon={faVideo}
          onDismiss={() => onDismiss(alert.collapseId)}
          onMaximize={() => onMaximize(alert.collapseId)}
          title={alert.text}
        />
      ))}
    </div>
  );
};

export default React.memo(MemberJoinedAlertBar);
